module.exports = __webpack_public_path__ + "static/media/america-puebla.0393f82e.jpg";